/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {UpdateDataTokenRequest} from "../model/update-data-token-request";

@Injectable({
    providedIn: "root",
})
export class SimTokenService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
/**
 * This method can be called by anonymous because, it is crucial to have access, when clicking auto-login links.
 */ 

    public getDataByToken(token: string) {
        return super.get<any>(`/api/Token/GetDataByToken`, {token: token});
    }

    public storeData(data: any) {
        return super.post<string>(`/api/Token/StoreData`, data);
    }

    public updateData(request: UpdateDataTokenRequest) {
        return super.post<string>(`/api/Token/UpdateData`, request);
    }
}